import parseNavigation from './parseNavigation';

/** Menú del rol comercializador: `tipo id | título | ícono | url`, anidado por tabulación. */
const marketerNavigation = parseNavigation(`
group marketer-certificates | Certificados | account_tree
	item marketer-certificate-avaibles | Certificados disponibles | check_circle_outline | /certificates/marketer/avaibles
	item marketer-certificate-nominees | Certificados nominados | person_pin | /certificates/marketer/nominees
	item marketer-circularity-available | Certificados de circularidad disponibles | recycling | /circularity/available
	item marketer-circularity-nominations | Certificados de circularidad nominados | how_to_reg | /circularity/consult/nominations
group marketer-consults | Consultas | account_tree
	item marketer-received-transfer-info | Certificados recibidos | move_to_inbox | /marketer/consult/received-transfer-info
	item marketer-transfer | Certificados disponibles | check_circle_outline | /marketer/consult/transfer
	item marketer-send-transfer-info | Certificados transferidos | send | /marketer/consult/send-transfer-info
	item marketer-circularity-received | Certificados de circularidad recibidos | move_to_inbox | /circularity/consult/received-transfer
	item marketer-circularity-sent | Certificados de circularidad transferidos | send | /circularity/consult/sent-transfer
`);

export default marketerNavigation;
